type TerritoryFilter = Array<{
  countries: Array<string>;
  label: string;
  value: string;
}>;

export const COUNTRY_TO_TERRITORY = {
  MEXICO: "mexico",
  KOREA: "korea",
  JAPAN: "japan",
  AUSTRALIA: "pacific",
  "NEW ZEALAND": "pacific",
  INDIA: "sea&i",
  INDONESIA: "sea&i",
  MALAYSIA: "sea&i",
  PHILIPPINES: "sea&i",
  "SEA EXPORT": "sea&i",
  SINGAPORE: "sea&i",
  THAILAND: "sea&i",
  VIETNAM: "sea&i",
  FISIA: "casa",
  "LATIN PARTNERS": "casa",
  SOCO: "casa",
};
export const TERRITORY_MENU_DATA: TerritoryFilter = [
  { label: "MEXICO", value: "MEXICO", countries: ["MEXICO"] },
  { label: "KOREA", value: "KOREA", countries: ["KOREA"] },
  { label: "JAPAN", value: "JAPAN", countries: ["JAPAN"] },
  {
    label: "PACIFIC",
    value: "PACIFIC",
    countries: ["AUSTRALIA", "NEW ZEALAND"],
  },
  {
    label: "SEA&I",
    value: "SEA&I",
    countries: [
      "INDIA",
      "INDONESIA",
      "MALAYSIA",
      "PHILIPPINES",
      "SEA EXPORT",
      "SINGAPORE",
      "THAILAND",
      "VIETNAM",
    ],
  },
  {
    label: "CASA",
    value: "CASA",
    countries: ["FISIA", "LATIN PARTNERS", "SOCO"],
  },
];

export const COUNTRIES = {
  MEXICO: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
    NSO: {
      "Nike Store Owned": "Nike Store Owned",
    },
    NVS: {
      "Nike Value Store": "Nike Value Store",
    },
    NDDC: {
      "Nike.com": "Nike.com",
      "3PP Consignment": {
        "Mercado Libre": "MERLIB",
      },
    },
  },
  JAPAN: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
    NSO: {
      "Nike Store Owned": "Nike Store Owned",
      "Nike Store Partners Hybrid": "Nike Store Partners Hybrid",
    },
    NVS: {
      "Nike Value Store": "Nike Value Store",
    },
    NDDC: {
      "Nike.com": "Nike.com",
      "3PP Consignment": {
        Rakuten: "RKTN",
        Zozo: "Zozo",
      },
    },
  },
  KOREA: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
    NSO: {
      "Nike Store Owned": "Nike Store Owned",
    },
    NVS: {
      "Nike Value Store": "Nike Value Store",
    },
    NDDC: {
      "Nike.com": "Nike.com",
      "3PP Consignment": {
        Musinsa: "MUS",
      },
    },
  },
  AUSTRALIA: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
    NSO: {
      "Nike Store Owned": "Nike Store Owned",
    },
    NVS: {
      "Nike Value Store": "Nike Value Store",
    },
    NDDC: {
      "Nike.com": "Nike.com",
    },
  },
  "NEW ZEALAND": {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
    NVS: {
      "Nike Value Store": "Nike Value Store",
    },
  },
  SINGAPORE: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
    NSO: {
      "Nike Store Owned": "Nike Store Owned",
    },
    NVS: {
      "Nike Value Store": "Nike Value Store",
    },
    NDDC: {
      "Nike.com": "Nike.com",
      "3PP Consignment": {
        Lazada: "Lazada",
      },
    },
  },
  MALAYSIA: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
    NVS: {
      "Nike Value Store": "Nike Value Store",
    },
    NDDC: {
      "3PP Consignment": {
        Lazada: "Lazada",
      },
    },
  },
  PHILIPPINES: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
    NDDC: {
      "3PP Consignment": {
        Lazada: "Lazada",
      },
    },
  },
  THAILAND: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
    NVS: {
      "Nike Value Store": "Nike Value Store",
    },
    NDDC: {
      "3PP Consignment": {
        Lazada: "Lazada",
      },
    },
  },
  INDONESIA: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
    NDDC: {
      "3PP Consignment": {
        Lazada: "Lazada",
      },
    },
  },
  VIETNAM: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
  },
  "SEA EXPORT": {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
    },
  },
  INDIA: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
      "Nike Store Partners": "Nike Store Partners",
    },
    NVS: {
      "Nike Value Store": "Nike Value Store",
    },
    NDDC: {
      "3PP Drop Ship": {
        "Flipkart Internet": "FLPKRT",
        Myntra: "Myntra",
      },
    },
  },
  FISIA: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
    },
  },
  "LATIN PARTNERS": {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
    },
  },
  SOCO: {
    "3PW": {
      "Nike Marketplace Partners": "Nike Marketplace Partners",
    },
  },
};
